import { Search } from "lucide-react";
import { Input } from "../../ui/input";
import CardPagination from "../CardPagination";
import "./ResourceRequests.css";

const REQUESTS_PER_PAGE = 15;

interface ResourceRequestToolbarProps {
  page: number;
  totalItems: number;
  onPageChange: (page: number) => void;
  searchTerm: string;
  onSearchChange: (value: string) => void;
}

export default function ResourceRequestToolbar({
  page,
  totalItems,
  onPageChange,
  searchTerm,
  onSearchChange,
}: ResourceRequestToolbarProps) {
  const totalPages = Math.max(1, Math.ceil(totalItems / REQUESTS_PER_PAGE));
  const firstItem = (page - 1) * REQUESTS_PER_PAGE + 1;
  const lastItem = Math.min(page * REQUESTS_PER_PAGE, totalItems);

  return (
    <div className="resource-request-toolbar">
      <div className="resource-request-toolbar-search">
        <Search className="resource-request-search-icon" />
        <Input
          aria-label="Search requests"
          placeholder="Search requests..."
          value={searchTerm}
          onChange={(event) => onSearchChange(event.target.value)}
          className="pl-10"
          data-testid="input-search"
        />
      </div>
      <div className="resource-request-toolbar-pages">
        {totalItems > 0 && firstItem <= totalItems && (
          <span className="resource-request-toolbar-count">
            Showing {firstItem}–{lastItem} of {totalItems}
          </span>
        )}
        <CardPagination
          currentPage={page}
          totalPages={totalPages}
          onPageChange={onPageChange}
          label="Resource request pages"
        />
      </div>
    </div>
  );
}
